import { render, staticRenderFns } from "./shimmer.vue?vue&type=template&id=8571dace"
import script from "./shimmer.vue?vue&type=script&lang=js"
export * from "./shimmer.vue?vue&type=script&lang=js"
import style0 from "./shimmer.vue?vue&type=style&index=0&id=8571dace&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports